const CHUNK_RECOVERY_KEY = 'vendapro:chunk-recovery-attempted';

const CHUNK_ERROR_PATTERNS = [
  'failed to fetch dynamically imported module',
  'importing a module script failed',
  'error loading dynamically imported module',
  'failed to load module script',
  'chunkloaderror'
];

function getErrorMessage(error: unknown): string {
  if (!error) {
    return '';
  }

  if (typeof error === 'string') {
    return error;
  }

  if (typeof error === 'object' && 'message' in error) {
    return String((error as { message?: unknown }).message || '');
  }

  return String(error);
}

export function isChunkLoadError(error: unknown): boolean {
  const message = getErrorMessage(error).trim().toLowerCase();

  if (!message) {
    return false;
  }

  return CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
}

export function resetChunkRecoveryAttempt(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage.removeItem(CHUNK_RECOVERY_KEY);
  } catch {
    // Ignora falhas de acesso ao storage.
  }
}

export function attemptChunkRecovery(reason: unknown): boolean {
  if (typeof window === 'undefined' || !isChunkLoadError(reason)) {
    return false;
  }

  try {
    if (window.sessionStorage.getItem(CHUNK_RECOVERY_KEY) === '1') {
      return false;
    }

    window.sessionStorage.setItem(CHUNK_RECOVERY_KEY, '1');
  } catch {
    // Se o storage falhar, ainda tentamos recarregar uma vez.
  }

  window.location.reload();
  return true;
}

export function installChunkRecoveryListener(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.addEventListener('vite:preloadError', (event: Event) => {
    const customEvent = event as CustomEvent<{ message?: string } | undefined>;
    const recoveryTriggered = attemptChunkRecovery(customEvent.payload || customEvent);

    if (recoveryTriggered) {
      event.preventDefault();
    }
  });

  window.addEventListener('pageshow', () => {
    resetChunkRecoveryAttempt();
  });
}
